import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Singleton } from '../../../js/Singleton';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { messageMarksCall } from '../../../redux/actions/A_messages_to_SM';
import { removeWindow } from '../../../redux/actions/A_draggable_windows_controller'
import { DRAGGABLE_WINDOWS, INTEGRATION } from '../../../constants';
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import { markSvg } from '../../../Images/CallRecordSVG';
import { addMark, mark } from '../../../Images/Images';
import MarkDetail from './MarkDetail';
import { getCurrentTimeInSec } from '../../../js/helpers/Utils/formats';
import { setMarks } from '../../../redux/actions/A_preview';

class CallMarks extends Component {
  constructor(props) {
    super(props);
    this.sharedData = new SingletonSharedData();
    this.language = new Singleton();
    this.state = {
      arrayMarks: this.props.simultaneosRecs ? this.props.selectedRecord.marks : this.sharedData.getCurrentCallMarks(),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.messagesIntegrations) {
      if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.CALL_ACTION && nextProps.messagesIntegrations.dataMessageIntegration.callAction === INTEGRATION.MARK_ADD) {
        let _this = this;
        _this.onAddMark();
      }
    }
  }

  deleteMark(mark) {
    let copyMark = this.state.arrayMarks;
    this.remove(copyMark, mark)
    this.updateStateMarks(copyMark);
  }

  remove(array, element) {
    const index = array.indexOf(element);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  sendMarks(currentMark) {
    let temp = currentMark.length > 0 ? (currentMark.map(m=>m.time).toString()).replace(',','|') : '';
    let callOutId = this.props.simultaneosRecs ? this.props.selectedRecord.callOutId : 0;
    this.props.messageMarksCall(temp,callOutId);
  }

  onAddMark() {
    let currentTimeInSeconds = !this.props.simultaneosRecs ? this.sharedData.getCurrentCallTime() : this.fullFormat(getCurrentTimeInSec() - this.props.initialDialogTime)
    this.updateStateMarks([...this.state.arrayMarks, {time: currentTimeInSeconds, index: (new Date()).getTime()}]);
  }

  updateStateMarks(currentMark) {
    this.setState({ arrayMarks: currentMark });
    this.sharedData.setCurrentCallMarks(currentMark);
    this.sendMarks(currentMark);
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.arrayMarks.length > 0 && this.state.arrayMarks.length > prevState.arrayMarks.length){
      let cur = "mark" + (this.state.arrayMarks.length - 1);
      const objDiv = document.getElementById(cur);
      objDiv.scrollIntoView({ block: 'end', behavior: 'smooth', inline: 'center' });
    }
    if(this.props.simultaneosRecs && (this.state.arrayMarks.length !== prevState.arrayMarks.length)){
      this.saveMarksPreviewSimultaneousRecs()
    }
  }
  componentDidMount() {
    if (this.state.arrayMarks.length === 0) {
      this.onAddMark();
    }
    else {
      if (this.props.objProps && this.props.objProps.action === INTEGRATION.MARK_ADD) {
        this.onAddMark();
      }
    }
  }
  onCloseWindow() {
    this.sharedData.setCurrentCallMarks(this.state.arrayMarks);
    this.props.removeWindow(DRAGGABLE_WINDOWS.MARK_CALL);
    this.props.simultaneosRecs && this.props.onCloseMarCallkWindow();
  }

  zeroPad(value) {
		return value.toString().padStart(2, '0');
	};

	fullFormat(totalSeconds){
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds / 60) % 60);
    const seconds = totalSeconds % 60;
		return `${this.zeroPad(hours)}:${this.zeroPad(minutes)}:${this.zeroPad(seconds)}`;
	};
  saveMarksPreviewSimultaneousRecs(){
    this.props.setMarks({callOutId: this.props.selectedRecord.callOutId, marks: this.state.arrayMarks});
  }

  render() {
    return (
      <div className="markCallContainer" onClick={() => this.props.goTopZ(this.props.id)}>
        {CUSTOM_COMPONENTS["draggableHeader"](markSvg,
          this.language.getText("CallControlGUICallMarktitle"),
          () => this.onCloseWindow())}
        <div className="markContainer">
          <div className="markContainerAllCell">
            {this.state.arrayMarks.map((mark, i) => {
              return <div id={"mark" + i}>
                        <MarkDetail
                          key={"mark" + i}
                          mark={mark}
                          onDeleteMark={(mark) => this.deleteMark(mark)} 
                        />
                    </div>
              
            })}
          </div>
          <div className="markButton" onClick={() => this.onAddMark()}>
            <img className="markIcon" src={mark} alt="icon"></img>
            <img className="addMarkIcon" src={addMark} alt="icon"></img>
          </div>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    messagesIntegrations: state.messagesIntegrations,
    selectedRecord: state.preview.selectedRecord,
    simultaneosRecs : state.preview.simultaneosRecs,
    records : state.preview.records
    //{(selectedRecord, simultaneosRecs)}=(state)
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
    messageMarksCall: (marks, callOutId) => { dispatch(messageMarksCall(marks, callOutId)) },
    setMarks:(marks)=>{dispatch(setMarks(marks))}
  })
}

export default CallMarks = connect(
  mapStateToProps,
  mapDispatchToProps
)(CallMarks);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/CallMark.jsx